<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="headers"
    :items="marks"
    :rows-per-page-items="[50]"
    class="elevation-1"
    hide-default-footer
  >
    <template v-slot:items="props">
      <td style="min-width: 120px; max-width: 120px;">{{ props.item.date }}</td>
      <td><a :href="userProfileBaseUrl + '/u/' + props.item.examinee.uid" target="_blank">{{ props.item.examinee.name }} {{ props.item.examinee.surname }}</a></td>
      <td>{{ props.item.level }}</td>
      <td>{{ props.item.task }}</td>
      <td>{{ props.item.mark }}</td>
      <td style="min-width: 700px; max-width: 700px;">{{ props.item.message }}</td>
      <td>{{ props.item.reason }}</td>
    </template>
  </v-data-table>
</template>

<script>
import {urls} from "@/config";

export default {
  name: "InflatedMarks",
  props: ['marks'],
  data () {
    return {
      userProfileBaseUrl: urls.signin,
      headers: [
        {
          text: 'Дата',
          align: 'left',
          sortable: false,
          value: 'date',
        },
        {
          text: 'Проверяемый',
          align: 'left',
          sortable: false,
          value: 'examinee',
        },
        {
          text: 'Лвл',
          align: 'left',
          sortable: false,
          value: 'level',
        },
        {
          text: 'Задание',
          align: 'left',
          sortable: false,
          value: 'task',
        },
        {
          text: 'Оценка',
          align: 'left',
          sortable: false,
          value: 'mark',
        },
        {
          text: 'Коммент',
          align: 'left',
          sortable: false,
          value: 'message',
        },
        {
          text: 'Причина добряка',
          align: 'left',
          sortable: false,
          value: 'reason',
        },
      ],
    }
  },
}
</script>

<style scoped>

</style>
